import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const Vision = () => {
    useEffect(() => {
        document.title = 'Vision -  Sacred Heart School, Ballia - U.P.';  
    }, []);  
   return (
        <>
        <Header/>
            <section className="page-header">
                <div className="page-header__inner">
                    <h2>Vision</h2>
                    <ul className="thm-breadcrumb list-unstyled ml-0">
                        <li><Link to="/"> Home</Link></li>
                        <li>|</li>
                        <li>About</li>
                        <li>|</li>
                        <li> Vision</li>
                    </ul>
                </div>
            </section>
            <section className="innerbody">
                <div className='container'>
                    <div className='row'>
                        
                        <div className='col-lg-6'>
                        <p>The vision of the education is to build a strong younger generation with a sound body and a well trained mind with good habits and accomplishments conducive to a full purposeful and noble life to blossom into an integrated personality. </p>
        
                        </div>
                        <div className='col-lg-6'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/vision.jpg" alt="Sacred Heart School, Ballia" className='img-fluid' /></LazyLoad>
                        </div>
                    </div>
                </div>
             </section>
            <Footer/>
        </>
    )
}

export default Vision